import { AuthEndpoint, AuthEndpointRoutes } from './auth.interface';

export class AuthEndpointFactory
{
	public static build(baseUrl: string): AuthEndpoint
	{
		return {
			baseUrl: baseUrl,
			routes: this.buildRoutes(baseUrl)
		};
	}
	private static buildRoutes(baseUrl: string): AuthEndpointRoutes
	{
		return {
			auth: {
				toString: () => `${baseUrl}v0/auth`,
				validUser: {
					toString: () => `${baseUrl}v0/auth/validUser`
				},
				permissions: {
					toString: () => `${baseUrl}v0/auth/permissions`,
					category: {
						toString: () => `${baseUrl}v0/auth/permissions/category`,
						id: (id: string) => `${baseUrl}v0/auth/permissions/category/${id}`
					}
				}
			}
		} as AuthEndpointRoutes;
	}
}
